var _rect, _rect2, _g, _rect3, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeSystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_8)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 100
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 14,
    fill: "#042F36",
    stroke: "#0C505A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 14,
    height: 85,
    fill: "#042F36",
    stroke: "#0C505A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 135,
    height: 85,
    fill: "#05292F",
    stroke: "#0C505A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_61_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 107,
    height: 27,
    rx: 3,
    fill: "url(#paint0_linear_61_8)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 28.5,
    width: 106,
    height: 26,
    rx: 2.5,
    stroke: "#0C505A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_61_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 63,
    width: 107,
    height: 27,
    rx: 3,
    fill: "url(#paint1_linear_61_8)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 63.5,
    width: 106,
    height: 26,
    rx: 2.5,
    stroke: "#0C505A"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_61_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 0,
    width: 75,
    height: 100
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    width: 75,
    height: 100,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_61_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 14,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 135,
    height: 85,
    fill: "#EBEBEB",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 28.5,
    width: 106,
    height: 26,
    rx: 2.5,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 63.5,
    width: 106,
    height: 26,
    rx: 2.5,
    fill: "white",
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 72V68.6667H93.6667V72H57ZM62 67C61.0833 67 60.2986 66.6736 59.6458 66.0208C58.9931 65.3681 58.6667 64.5833 58.6667 63.6667V45.3333C58.6667 44.4167 58.9931 43.6319 59.6458 42.9792C60.2986 42.3264 61.0833 42 62 42H88.6667C89.5833 42 90.3681 42.3264 91.0208 42.9792C91.6736 43.6319 92 44.4167 92 45.3333V63.6667C92 64.5833 91.6736 65.3681 91.0208 66.0208C90.3681 66.6736 89.5833 67 88.6667 67H62ZM62 63.6667H88.6667V45.3333H62V63.6667Z",
    fill: "#28AC47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_61_8",
    x: 25,
    y: 28,
    width: 115,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_8",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_61_8",
    x: 25,
    y: 63,
    width: 115,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_8",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_8",
    x1: 29,
    y1: 41.5,
    x2: 136,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#042F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495242,
    stopColor: "#08424C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_8",
    x1: 29,
    y1: 76.5,
    x2: 136,
    y2: 76.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#042F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495242,
    stopColor: "#08424C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042F36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeSystem);
export default __webpack_public_path__ + "static/media/theme-system.f5cd765913b33cfd8e39ea979c34ea15.svg";
export { ForwardRef as ReactComponent };